import React from 'react';
import AssetObject from './AssetObject';
import AssetImage from './AssetImage';

var AssetRenderer = function AssetRenderer(_ref) {
  var assetPath = _ref.assetPath,
      assetWidth = _ref.assetWidth,
      altText = _ref.altText;
  var fileExt = assetPath && assetPath.substring(assetPath.lastIndexOf('.') + 1);
  var renderAsset = assetPath && fileExt === 'svg' ? /*#__PURE__*/React.createElement(AssetObject, {
    data: assetPath,
    type: "image/svg+xml",
    assetWidth: assetWidth,
    alt: altText
  }) : /*#__PURE__*/React.createElement(AssetImage, {
    src: assetPath,
    alt: altText,
    assetWidth: assetWidth
  });
  return renderAsset;
};

AssetRenderer.defaultProps = {
  path: undefined,
  assetWidth: undefined,
  altText: ''
};
export default AssetRenderer;